import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../../components/Modal/ModalContext';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useDelistVehicle = () => {
  const modalContext = useContext(ModalContext);
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onDelistVehicleError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
      'Something went wrong while de-listing vehicle.',
    );
  };

  const onDelistVehicleSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success('Vehicle delisted successfully.');
    modalContext?.setShowModal(false);
  };

  const delistVehicle = async (data: any) => {
    const url: HttpConfig = {
      url: `api/v1/fleets/${data.id}/toggle-status`,
      method: 'post',
      data: data,
    };
    await request(url, onDelistVehicleSuccess, setLoading, onDelistVehicleError);
  };

  return { delistVehicle, loading };
};

export default useDelistVehicle;
